<template>
  <form class="form" @submit.prevent="onSubmit">
    <div class="form__inner">
      <VProfile v-model:image="formData.avatar" class="mb-40" :avatar="avatar">
        <div class="profile__form">
          <VInput
            id="name"
            v-model="formData.name"
            name="name"
            validator-name="onlyText"
            placeholder="Контактное лицо ФИО*"
            :class-input="['input input-border-all input-placeholder-black']"
            :errors="v$.name.$errors"
            :server-errors="serverErrors.value?.name"
            @blur="validateField"
            @input="validateField" />

          <VPhone
            id="phone"
            v-model="formData.phone"
            type="phone"
            name="phone"
            placeholder="Номер телефона"
            mask-type
            :class-input="['input input-border-all input-placeholder-black']"
            :errors="v$.phone.$errors"
            :server-errors="serverErrors.value?.phone"
            @blur="validateField"
            @input="validateField" />
        </div>
      </VProfile>

      <div class="form__grid form__grid--col-2">
        <VInput
          id="login"
          v-model="formData.login"
          name="login"
          placeholder="Логин (мин. 3 символа)*"
          :class-input="['input input-placeholder-black']"
          :errors="v$.login.$errors"
          :server-errors="serverErrors.value?.login"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="organization_legal_address"
          v-model="formData.organization_legal_address"
          name="organization_legal_address"
          :errors="v$.organization_legal_address.$errors"
          :server-errors="serverErrors.value?.organization_legal_address"
          :class-input="['input input-placeholder-black']"
          placeholder="Юр. адрес организации*"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="organization_actual_address"
          v-model="formData.organization_actual_address"
          name="organization_actual_address"
          :class-input="['input input-long input-placeholder-black input-border-bottom']"
          placeholder="Почтовый адрес организации" />

        <VInput
          id="email"
          v-model="formData.email"
          name="email"
          placeholder="Адрес электронной почты*"
          :class-input="['input input-placeholder-black']"
          :errors="v$.email.$errors"
          :server-errors="serverErrors.value?.email"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="organization_index"
          v-model="formData.organization_index"
          name="organization_index"
          type="number"
          validator-name="onlyNumber"
          :max-length="6"
          placeholder="Почтовый индекс организации*"
          :class-input="['input input-placeholder-black']"
          :errors="v$.organization_index.$errors"
          :server-errors="serverErrors.value?.organization_index"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="msrn"
          v-model="formData.msrn"
          name="msrn"
          type="number"
          validator-name="onlyNumber"
          placeholder="ОГРН*"
          :class-input="['input input-placeholder-black', disabledField ? 'disabled' : '']"
          :class-label="disabledField ? 'disabled' : ''"
          :disabled="disabledField"
          :errors="v$.msrn.$errors"
          :server-errors="serverErrors.value?.msrn"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="kpp"
          v-model="formData.kpp"
          name="kpp"
          type="number"
          validator-name="onlyNumber"
          :errors="v$.kpp.$errors"
          :server-errors="serverErrors.value?.kpp"
          :class-input="[
            'input input-long input-placeholder-black input-border-bottom',
            disabledKpp ? 'disabled' : '',
          ]"
          :class-label="disabledKpp ? 'disabled' : ''"
          :disabled="disabledKpp"
          placeholder="КПП"
          @blur="validateField"
          @input="validateField" />

        <VSelect
          id="partner_type_id"
          v-model="formData.partner_type_id"
          classes="select-border-bottom"
          name="partner_type_id"
          placeholder="Тип контрагента*"
          :options="listTypeContrAgent"
          :errors="v$.partner_type_id.$errors"
          :server-errors="serverErrors.value?.partner_type_id"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="arctea"
          v-model="formData.arctea"
          name="arctea"
          type="text"
          validator-name="onlyNumber"
          :errors="v$.arctea.$errors"
          :server-errors="serverErrors.value?.arctea"
          :class-input="['input input-long input-placeholder-black input-border-bottom']"
          placeholder="ОКВЭД*"
          @blur="validateField"
          @input="validateField" />

        <VSelect
          id="organization_type_id"
          v-model="formData.organization_type_id"
          classes="select-border-bottom"
          name="organization_type_id"
          placeholder="Тип организации*"
          :options="listTypeOrganization"
          :errors="v$.organization_type_id.$errors"
          :server-errors="serverErrors.value?.organization_type_id"
          @blur="validateField"
          @input="
            (val) => {
              if (val === 2) resetValidateField('msrn')
              validateField
            }
          " />

        <VInput
          id="director"
          v-model="formData.director"
          name="director"
          validator-name="onlyText"
          placeholder="Руководитель организации*"
          :class-input="['input input-placeholder-black']"
          :errors="v$.director.$errors"
          :server-errors="serverErrors.value?.director"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="inn"
          v-model="formData.inn"
          name="inn"
          type="number"
          validator-name="onlyNumber"
          placeholder="ИНН*"
          :class-input="['input input-placeholder-black']"
          :errors="v$.inn.$errors"
          :server-errors="serverErrors.value?.inn"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="trusted_person"
          v-model="formData.trusted_person"
          name="trusted_person"
          placeholder="Действующий по доверенности"
          :class-input="['input input-placeholder-black']"
          :server-errors="serverErrors.value?.trusted_person"
          @blur="validateField"
          @input="validateField" />

        <VInput
          id="organization_name"
          v-model="formData.organization_name"
          name="organization_name"
          placeholder="Сокращенное наименование организации*"
          :class-input="['input input-long input-placeholder-black']"
          :errors="v$.organization_name.$errors"
          :server-errors="serverErrors.value?.organization_name"
          @blur="validateField"
          @input="validateField" />
      </div>

      <div class="form__subtitle mb-40">Документы</div>
      <VFileList
        v-if="!currentUserIsBidder && getFiles?.length"
        class="mb-20"
        :files="getFiles"
        show-delete
        grid
        @on-delete="handlerDelete" />

      <div v-if="currentUserIsBidder">
        <VFile
          v-for="(item, i) of filesTypeList"
          :id="item.type"
          :key="i"
          v-model="formData[item.type]"
          :title="item.text"
          class="box max-w-initial mb-20"
          :name="item.type"
          icon-name-btn-delete="YellowDelete"
          multi-file
          grid
          push-model-value
          :errors="v$[item.type].$errors"
          @on-delete-file="handlerDelete" />
      </div>

      <VFile
        id="files"
        v-model="formData.files"
        :title="currentUserIsBidder ? 'Прочие документы' : ''"
        class="max-w-initial"
        :class="currentUserIsBidder && 'box'"
        name="files"
        :icon-name-btn-delete="currentUserIsBidder ? 'YellowDelete' : 'DeleteFile'"
        multi-file
        grid
        :push-model-value="currentUserIsBidder"
        @on-delete-file="handlerDelete" />

      <div class="form__buttons form__buttons-setting">
        <VButtonLoading :is-disabled="isSend" :is-errors="v$.$error" type="submit" color="green">
          Сохранить
        </VButtonLoading>
        <button class="btn btn-primary btn-bg-transparent" type="button" @click="goBack">
          Отмена
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import VFile from '@/components/ui/form/File/VFile'
import VInput from '@/components/ui/form/VInput'
import VPhone from '@/components/ui/form/VMask'
import VProfile from '@/components/profile/VProfile'
import VSelect from '@/components/ui/form/VSelect'
import { goBack } from '@/utils/goRoute'
import { useEditUserForm } from '@/use/Form/PersonalArea/useEditUserForm'
import { ref, computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import VFileList from '@/components/list/FileList/VFileList'
import VButtonLoading from '@/components/ui/buttons/VButtonLoading'
import { Alert } from '@/extension/Alert/Alert'
import { manualMemoization } from '@/utils/memoization/manualMemoization'
import { ORGANIZATIONS, PARTNERS } from '@/utils/manual/manualList'

export default {
  components: {
    VButtonLoading,
    VSelect,
    VPhone,
    VInput,
    VFile,
    VProfile,
    VFileList,
  },
  props: {
    avatar: {
      type: [String, null],
      required: false,
    },
  },
  setup() {
    const route = useRoute()
    const store = useStore()

    const listTypeOrganization = ref([])
    const listTypeContrAgent = ref([])
    onBeforeMount(async () => {
      try {
        await store.dispatch('user/setUser', route.params.id)
      } catch (e) {
        await Alert.show('error', 'Не удалось загрузить данные о пользователе')
      }
      listTypeOrganization.value = await manualMemoization(false, ORGANIZATIONS)
      listTypeContrAgent.value = await manualMemoization(false, PARTNERS)
    })

    const getFiles = computed(() => {
      return store.getters['files/getFiles']
    })

    const getIsAlert = computed(() => {
      return store.getters.getAlert
    })

    const handlerDelete = (file) => {
      store.commit('files/deleteFile', file)
    }

    return {
      handlerDelete,
      goBack,
      listTypeOrganization,
      listTypeContrAgent,
      getIsAlert,
      ...useEditUserForm(),
      getFiles,
    }
  },
}
</script>
